import { render, staticRenderFns } from "./edit-sub-category.vue?vue&type=template&id=5586f9c3&"
import script from "./edit-sub-category.vue?vue&type=script&lang=js&"
export * from "./edit-sub-category.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports